/*
 ***********************************************************
 ** TZStringConvFunct - Gestione delle conversioni stringhe
 ** Versione 2.1  17 Aprile 2023 - Massimiliano Zirilli
 **               - NEW: Aggiunta la funzione MoveStringToBlob
 ** Versione 2.0  06 Dicembre 2022 - NON RETROCOMPATIBILE
 **               - NEW: L'oggetto diventa una classe
 ** Versione 1.1  19 Ottobre 2021
 **               - NEW: Aggiunta funzione che converte una stringa in un blob
 ** Versione 1.0  12 Agosto 2020
 **               - Prima versione
 ***********************************************************/
 
 export class TZStringConvFunct  
 {
      static Base64AsBlob(Base64)
      {
         var binary = atob(Base64);
         var array = new Uint8Array(binary.length);
         for( var i = 0; i < binary.length; i++ )
             array[i] = binary.charCodeAt(i);
         return(new Blob([array]));
      }

      static MoveStringToBlob(Stringa)
      {
         var array = new Uint8Array(Stringa.length);
         for( var i = 0; i < Stringa.length; i++ )
             array[i] = Stringa.charCodeAt(i);
         return(new Blob([array]));
      }
      
      static SplitCSVWithDoublequotes(AString,Delimiter = ',') 
      {  
         const QUOTES = '"';  
         var Elemento = '';
         var InString = false;
         var Result = [];
         for (var i = 0; i < AString.length; ++i) 
         {  
             if(InString)
             {
               if(AString.charAt(i) == QUOTES)
               InString = false;
               else Elemento += AString.charAt(i);
             }
             else       
             {
               if(AString.charAt(i) == QUOTES)
                  InString = true;
              else 
              {
                  if(AString.charAt(i) == Delimiter)
                  {
                     Result.push(Elemento);
                     Elemento = '';
                  }
                  else Elemento += AString.charAt(i);
              }
             }
         }
         if (Elemento != '') 
            Result.push(Elemento);       
         
         return Result;  
      }

}
